export default "__VITE_ASSET__CxiQH26M__";